import { Button, Stack } from '@mui/material';
import { useCallback } from 'react';
import { DeepPartial, FieldValues, UnpackNestedValue, useFormContext } from 'react-hook-form';

interface FormSubmitButtonProps<T extends FieldValues> {
  defaultForm?: UnpackNestedValue<DeepPartial<T>>;
  submitText?: string;
  resetText?: string;
  form?: string;
}

export function FormSubmitButton<T extends FieldValues>({
  form,
  defaultForm,
  resetText = 'reset',
  submitText = 'save',
}: FormSubmitButtonProps<T>) {
  const {
    formState: { isDirty, isSubmitting },
    reset,
  } = useFormContext<T>();

  const resetForm = useCallback(() => {
    reset(defaultForm);
  }, [reset, defaultForm]);

  return isDirty ? (
    <Stack direction='row' spacing={1}>
      <Button disabled={isSubmitting} form={form} type='submit' color='primary' variant='contained'>
        {submitText}
      </Button>
      {Boolean(defaultForm) && (
        <Button disabled={isSubmitting} onClick={resetForm} variant='outlined'>
          {resetText}
        </Button>
      )}
    </Stack>
  ) : null;
}
